export default __webpack_public_path__ + "static/media/new_goal.1dd54b5d.png";